var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaving(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_radial_13657_36369)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13657_36369)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13657_36369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 33,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6666,
    y: 12,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13657_36369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5666 39.9974C20.0555 39.9974 19.561 39.8196 19.0833 39.4641C18.6055 39.1085 18.2888 38.6752 18.1333 38.1641C17.5777 36.2974 17.1221 34.6807 16.7666 33.3141C16.411 31.9474 16.1277 30.7474 15.9166 29.7141C15.7055 28.6807 15.5555 27.7641 15.4666 26.9641C15.3777 26.1641 15.3333 25.3974 15.3333 24.6641C15.3333 22.6196 16.0444 20.8863 17.4666 19.4641C18.8888 18.0418 20.6221 17.3307 22.6666 17.3307H29.3333C29.9333 16.5307 30.6944 15.8863 31.6166 15.3974C32.5388 14.9085 33.5555 14.6641 34.6666 14.6641C35.2221 14.6641 35.6944 14.8585 36.0833 15.2474C36.4721 15.6363 36.6666 16.1085 36.6666 16.6641C36.6666 16.7974 36.6499 16.9307 36.6166 17.0641C36.5833 17.1974 36.5444 17.3196 36.4999 17.4307C36.411 17.6752 36.3277 17.9196 36.2499 18.1641C36.1721 18.4085 36.111 18.6752 36.0666 18.9641L39.0999 21.9974H40.6666C41.0444 21.9974 41.361 22.1252 41.6166 22.3807C41.8721 22.6363 41.9999 22.953 41.9999 23.3307V30.3307C41.9999 30.6196 41.9166 30.8752 41.7499 31.0974C41.5833 31.3196 41.3555 31.4863 41.0666 31.5974L38.2333 32.5307L36.5666 38.0974C36.3888 38.6752 36.0666 39.1363 35.5999 39.4807C35.1333 39.8252 34.5999 39.9974 33.9999 39.9974H31.3333C30.5999 39.9974 29.9721 39.7363 29.4499 39.2141C28.9277 38.6918 28.6666 38.0641 28.6666 37.3307H25.9999C25.9999 38.0641 25.7388 38.6918 25.2166 39.2141C24.6944 39.7363 24.0666 39.9974 23.3333 39.9974H20.5666ZM33.9999 26.6641C34.3777 26.6641 34.6944 26.5363 34.9499 26.2807C35.2055 26.0252 35.3333 25.7085 35.3333 25.3307C35.3333 24.953 35.2055 24.6363 34.9499 24.3807C34.6944 24.1252 34.3777 23.9974 33.9999 23.9974C33.6221 23.9974 33.3055 24.1252 33.0499 24.3807C32.7944 24.6363 32.6666 24.953 32.6666 25.3307C32.6666 25.7085 32.7944 26.0252 33.0499 26.2807C33.3055 26.5363 33.6221 26.6641 33.9999 26.6641ZM28.6666 23.9974C29.0444 23.9974 29.361 23.8696 29.6166 23.6141C29.8721 23.3585 29.9999 23.0418 29.9999 22.6641C29.9999 22.2863 29.8721 21.9696 29.6166 21.7141C29.361 21.4585 29.0444 21.3307 28.6666 21.3307H24.6666C24.2888 21.3307 23.9721 21.4585 23.7166 21.7141C23.461 21.9696 23.3333 22.2863 23.3333 22.6641C23.3333 23.0418 23.461 23.3585 23.7166 23.6141C23.9721 23.8696 24.2888 23.9974 24.6666 23.9974H28.6666Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13657_36369",
    x: 9.33325,
    y: 10.6641,
    width: 38.6666,
    height: 37.3359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0 0 0 0 0 0.709804 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13657_36369"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13657_36369",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13657_36369",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8333 16) rotate(48.9452) scale(61.6644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F600B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaving);
export default __webpack_public_path__ + "static/media/saving.9d431318638232c91d10c806a0a3b9a3.svg";
export { ForwardRef as ReactComponent };